
const Index = () => import(/* webpackChunkName: "lead" */ './index.vue');
const Profile = () => import(/* webpackChunkName: "lead" */ './view/Profile.vue');
const List = () => import(/* webpackChunkName: "lead" */ './components/List.vue');

export default [
  {
    path: 'applications',
    name: 'applications',
    component: Index,
    title: 'applications',
    redirect: { name: 'applications-list' },
    children: [      
      {
        path: ':id/profile',
        name: 'applications-profile',
        component: Profile,
      },
      {
        path: 'list',
        name: 'applications-list',
        component: List,
      },      
    ],
  },
]
